module.exports = __webpack_public_path__ + "img/info.22ad8b00.png";